module.exports = __webpack_public_path__ + "img/269-6.c3dff430.png";